// Possibly to reuse in the future due to other kind of events/sessions/reviews
export const KIND_OF_REVIEW_STATE = {
    BARS: 'bars',
    ED_REVIEW: 'edReview',
};